import React from "react";
import { Route, Routes } from "react-router-dom";
import ExpenseTransaction from "../pages/Transactions/ExpenseTransaction";
import PrintExpenseTransaction from "../pages/Transactions/PrintExpenseTransaction";

const TransactionRoutes = () => {
  return (
    <Routes>
      <Route path="/expense" element={<ExpenseTransaction />} />
      <Route path="/expense/print" element={<PrintExpenseTransaction />} />
    </Routes>
  );
};

export default TransactionRoutes;
